import { useSyncStore, syncColor } from '../../stores/sync'

export default function SyncBar() {
  const { status, lastPull, forcePull, forcePush } = useSyncStore()
  const color = syncColor(status)
  const label = status === 'pulling' ? 'Pulling…'
    : status === 'pushing' ? 'Pushing…'
    : status === 'error'   ? 'Sync error'
    : status === 'ok'      ? 'Synced'
    : 'Idle'

  const lastPullStr = lastPull
    ? new Date(lastPull).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    : '—'

  const btn: React.CSSProperties = {
    background: '#1e2d45', border: '1px solid #1e3a5f',
    borderRadius: 6, color: '#94a3b8', fontSize: 11,
    padding: '3px 10px', cursor: 'pointer',
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ width: 8, height: 8, borderRadius: '50%', background: color, flexShrink: 0 }} />
      <span style={{ fontSize: 11, color }}>{label}</span>
      {lastPull > 0 && <span style={{ fontSize: 11, color: '#475569' }}>Last pull {lastPullStr}</span>}
      <button style={btn} onClick={() => forcePull()}>⬇ Pull</button>
      <button style={btn} onClick={() => forcePush()}>⬆ Push</button>
    </div>
  )
}
